(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 89208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6065);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var shared_lib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18874);

const pages = {
    index: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/"),
    login: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/login"),
    signup: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/signup"),
    logout: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/logout"),
    dashboard: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/dashboard"),
    introduce: {
        yourself: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/introduce/yourself"),
        company: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/introduce/company")
    },
    profile: {
        ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/profile"),
        settings: "/profile/settings"
    },
    company: (company)=>({
            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company)),
            finances: {
                ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances")),
                education: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/education")),
                    tableOfContent: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/education/table-of-content")),
                    step: (step)=>(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/education/").concat((step.toString().length === 1 ? "0" : "") + step.toString()))
                },
                yearMonth: (year, month)=>({
                        ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month)),
                        plan: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/plan")),
                        fact: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/fact")),
                        results: {
                            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results")),
                            id: (id)=>({
                                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id)),
                                    fundingRequests: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id, "/funding-requests")),
                                    loans: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id, "/loans")),
                                    funds: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id, "/funds")),
                                    directive: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id, "/directive"))
                                })
                        }
                    }),
                plan: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/plan")),
                funds: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds")),
                    fundId: (fundId)=>({
                            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId)),
                            expenseItems: {
                                ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/expense-items")),
                                edit: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/expense-items/edit"))
                            },
                            history: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/history")),
                            fundingRequests: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/funding-requests")),
                            settings: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/settings"))
                        })
                },
                fundingRequests: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funding-requests")),
                    new: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funding-requests/new")),
                    id: (id)=>({
                            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funding-requests/").concat(id)),
                            edit: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funding-requests/").concat(id, "/edit"))
                        })
                },
                payouts: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/payouts")),
                    history: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/payouts/history"))
                },
                deferredIncomes: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/deferred-incomes")),
                    id: (id)=>(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/deferred-incomes/").concat(id))
                },
                loans: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/loans")),
                settings: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/settings")),
                reports: {
                    balance: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/balance")),
                    cashFlow: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/cash-flow")),
                    expenses: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/expenses")),
                    loans: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/loans")),
                    activeFundingRequests: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/active-funding-requests"))
                }
            },
            departments: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/departments")),
            settings: {
                ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/settings")),
                users: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/settings/users")),
                roles: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/settings/roles")),
                general: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/settings/general"))
            }
        }),
    admin: {
        ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin"),
        company: (companySlug)=>({
                ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/".concat(companySlug)),
                profile: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/".concat(companySlug, "/profile")),
                courses: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/".concat(companySlug, "/courses")),
                mentors: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/".concat(companySlug, "/mentors"))
            }),
        invites: {
            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/invites"),
            id: (id)=>(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/invites/".concat(id))
        },
        settings: {
            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/settings"),
            members: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/settings/members"),
            courses: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/settings/courses"),
            mailings: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/settings/mailings")
        }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (pages);


/***/ }),

/***/ 6065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var modules_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70281);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pages_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8254);





const IndexPage = ()=>{
    const authed = (0,modules_auth__WEBPACK_IMPORTED_MODULE_3__/* .useAuthed */ .p)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (authed) {
            next_router__WEBPACK_IMPORTED_MODULE_2___default().replace(pages_router__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dashboard.href */ .Z.dashboard.href);
        } else {
            next_router__WEBPACK_IMPORTED_MODULE_2___default().replace(pages_router__WEBPACK_IMPORTED_MODULE_4__/* ["default"].signup.href */ .Z.signup.href);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
};
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ }),

/***/ 18874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; },
/* harmony export */   "l": function() { return /* binding */ useRouterChange; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const page = (href)=>({
        href
    });
const useRouterChange = function(callback) {
    let deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        next_router__WEBPACK_IMPORTED_MODULE_0___default().events.on("routeChangeStart", callback);
        return ()=>next_router__WEBPACK_IMPORTED_MODULE_0___default().events.off("routeChangeStart", callback);
    }, deps);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(89208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);